import { Info } from 'lucide-react';

/**
 * How the register is kept. A note only — applying for leave is the leave
 * card's job, directly below, so the page offers it once.
 */
export function AttendanceNoteBanner() {
  return (
    <div className="rounded-2xl sm:rounded-3xl border border-indigo-200/90 dark:border-slate-800 bg-indigo-50/80 dark:bg-slate-900 p-4 sm:px-5 sm:py-4 flex flex-col md:flex-row md:items-center md:justify-between gap-4 shadow-xs">
      {/* Left: Info & Description */}
      <div className="flex items-center gap-3.5">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl sm:rounded-2xl bg-indigo-600 text-white shadow-xs">
          <Info className="h-5 w-5" />
        </div>
        <div>
          <h3 className="text-base font-bold text-indigo-950 dark:text-indigo-400">Note</h3>
          <p className="text-sm font-semibold text-slate-600 dark:text-slate-400 ">
            Attendance is marked by your school, so today’s record may still change during the day.
          </p>
        </div>
      </div>
    </div>
  );
}
